/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#raw-output-container[_ngcontent-%COMP%], #testingOutput[_ngcontent-%COMP%]{margin-top:1rem}"];
export { styles as styles };

